import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-n-small', 'IconLetterNSmall', [["path",{"d":"M10 16v-8l4 8v-8","key":"svg-0"}]]);